import DialogInternational from './DialogInternational'

export default DialogInternational
